'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _classList = require('class-list');

var _classList2 = _interopRequireDefault(_classList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Modal = function (_Component) {
	_inherits(Modal, _Component);

	function Modal(props) {
		_classCallCheck(this, Modal);

		var _this = _possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).call(this, props));

		_this.state = Object.assign(_this.state || {}, { opened: false });
		_this.close = _this.close.bind(_this);
		return _this;
	}

	_createClass(Modal, [{
		key: 'render',
		value: function render() {
			return _react2.default.createElement(
				'div',
				{ className: _classList2.default.join.apply(_classList2.default, _toConsumableArray(this.classList)) },
				_react2.default.createElement(
					'div',
					{ className: 'inner-content col-md-8' },
					this.content
				),
				_react2.default.createElement('img', { onClick: this.close, className: 'glyphicon-remove side-nav-remove-icon', src: '/admin/platform/plugins/com.sightworks.5.Channel.instance.marketing/resources/images/close-white.png' })
			);
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			var _this2 = this;

			setTimeout(function () {
				_this2.setState({
					opened: true
				});
				_classList2.default.add(document.body, 'modal-open');
			}, 0);
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate() {
			var _this3 = this;

			if (this.props.root && !this.state.opened) {
				setTimeout(function () {
					_reactDom2.default.unmountComponentAtNode(_this3.props.root);
				}, 500);
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			_classList2.default.remove(document.body, 'modal-open');
			if (this.props.root) {
				this.props.root.remove();
			}
		}
	}, {
		key: 'close',
		value: function close() {
			this.setState({
				opened: false
			});
			_classList2.default.remove(document.body, 'modal-open');
		}
	}, {
		key: 'content',
		get: function get() {
			return this.props.children;
		}
	}, {
		key: 'classList',
		get: function get() {
			return ['share-modal', this.state.opened ? 'modal-expanded' : null, this.props.className];
		}
	}], [{
		key: 'showModal',
		value: function showModal(modal) {
			var root = document.createElement('div');
			document.body.appendChild(root);
			var Type = modal.type;
			_reactDom2.default.render(_react2.default.createElement(Type, _extends({ root: root }, modal.props)), root);
		}
	}]);

	return Modal;
}(_react.Component);

exports.default = Modal;